import { countries } from "components/resources/countries";
import { REACT_APP_COUNTRY_DEPLOY, REACT_APP_FLYWIRE_CODE_OTHER, REACT_APP_FLYWIRE_CODE_US } from "config";

const UNITED_STATES = 'US';

const uuidv4 = () => {
    return "10000000100040008000100000000000".replace(/[018]/g, c =>
      ((+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & 15)) >> (+c / 4)).toString(16)
    );
}

const getFlywireCode = (country:string, region:string) => {
  let flywireCode = REACT_APP_FLYWIRE_CODE_OTHER;
  if (country === UNITED_STATES) {
    flywireCode = REACT_APP_FLYWIRE_CODE_US;
  }
  return flywireCode;
}

const getApiKey = (region:string) => {
  return process.env.REACT_APP_OLE_API_KEY || 'admin';
}

function getAmountWithTwoDecimalsAndMilles(amount: number, country: string): string {
    if (amount === null || amount === undefined || isNaN(amount)) {
        return '';
    }
    let amountString = amount.toFixed(2);
    if (country === 'BR') {
        amountString = amountString.replace('.', ',');
        const parts = amountString.split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        amountString = parts.join(',');
    } else {
        const parts = amountString.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        amountString = parts.join('.');
    }
    return amountString;
}

const getStates = (countryCurrent: string) => {
  const states = countries.find(country => country.code === countryCurrent)?.states || [];
  return states;
}

const getCities = (countryCurrent: string, stateCurrent: string) => {
  const states = getStates(countryCurrent);
  const cities = states.find(state => state.code === stateCurrent)?.cities || [];
  return cities;
}

const getCityCodeByName = (countryCurrent: string, stateCurrent: string, cityValue: string) => {
  const cities = getCities(countryCurrent, stateCurrent);
  const city = cities.find(city => city.name.toLowerCase() === cityValue.toLowerCase());
  return city ? city.code : '';
}

const getCityCodeByZone = (countryCurrent: string, stateCurrent: string, cityValue:string) => {
  const zone = REACT_APP_COUNTRY_DEPLOY;
  switch (zone) {
    case 'BR':
      if (countryCurrent === 'BR' && stateCurrent && cityValue) {
        return getCityCodeByName(countryCurrent, stateCurrent, cityValue);
      }
      return cityValue;
    default:
      return cityValue;
  }
}

export { uuidv4, getFlywireCode, getApiKey, getAmountWithTwoDecimalsAndMilles, getStates, getCities, getCityCodeByName, getCityCodeByZone };